import {
  MEMBER_GET_FOLDER,
  MEMBER_SET_AGREE,
} from 'volto-m4-theme-addon/constants/MemberActionTypes';

/**
 * Get request key
 * @function getRequestKey
 * @param {string} actionType Action type.
 * @returns {string} Request key.
 */
function getRequestKey(actionType) {
  return actionType.split('_')[0].toLowerCase();
}

const initialState = {
  member: {
    member: null,
    loaded: false,
    loading: false,
    error: null,
  },
};

export default function memberFolder(state = initialState, action = {}) {
  switch (action.type) {
    case `${MEMBER_GET_FOLDER}_PENDING`:
    case `${MEMBER_SET_AGREE}_PENDING`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          member: null,
          loading: true,
          loaded: false,
          error: null,
        },
      };
    case `${MEMBER_GET_FOLDER}_SUCCESS`:
    case `${MEMBER_SET_AGREE}_SUCCESS`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          member: action.result,
          loading: false,
          loaded: true,
          error: null,
        },
      };
    case `${MEMBER_GET_FOLDER}_FAIL`:
    case `${MEMBER_SET_AGREE}_FAIL`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          member: null,
          loading: false,
          loaded: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
}
